'use client';

import { isProduction } from '@qlevr/shared/utilities';
import { useEffect } from 'react';

export function CookieConsent({ scriptSrc }: { scriptSrc: string }) {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = scriptSrc;
    script.type = 'text/javascript';
    script.async = true;

    if (isProduction()) {
      document.body.appendChild(script);
    }

    return () => {
      if (isProduction()) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return null;
}

export default CookieConsent;